export const USER_TYPE_HG_ADMIN_GROUP = [100000, 999999]

export const STATUS = {
  ENABLE: 1,
  DISABLE: 0
}

export const COMPANY_TYPE = {
  GROUP: 0,
  STANDALONE: 1
}

export const SUPPLEMENT_UNIT_TYPE = {
  PER_PERSON: 1,
  PER_ROOM: 2,
  PER_BOOKING: 3,
  DISCOUNT: 4
}

export const SUPPLEMENT_PRICE_TYPE = {
  NET: 1,
  PERCENT: 2
}

export const SUPPLEMENT_TYPE = {
  OTHER: 0
}

export const AGENT_TYPE = {
  OTHER: 0
}

export const TRANSFER_TYPE = {
  PER_CAR: 1,
  PER_PERSON: 2
}

export const CONTRACT_STATUS = {
  DRAFT: 10,
  PUBLISHED: 100
}

export const SPECIAL_OFFER_STATUS = {
  DRAFT: 10,
  PUBLISHED: 100
}

export const SPECIAL_OFFER_REF_CODE_TYPE = {
  AGENT_NAME: 1
}

export const SORT_TYPE = {
  ASC: 1,
  DESC: -1
}

export const REMARK_TYPE = {
  CONTRACT: 'contract',
  RATE_CODE: 'rate-code',
  ALLOTMENT: 'allotment',
  SUPPLEMENT: 'supplement',
  PROMOTION: 'promotion',
  TRANSFER: 'transfer'
}

export const VUEX_EVENT = {
  GENERAL: {
    SET_ACTIVE_COMPANY_ID: 'general/setActiveCompanyId',
    SET_ACTIVE_HOTEL_ID: 'general/setActiveHotelId',
    SET_ACTIVE_AGENT_ID: 'general/setActiveAgentId',
    SET_HOTEL_LIST: 'general/setHotelList',
    RESTORE_STATE: 'general/restoreState'
  },
  CONTRACT: {
    CLEAR_MAP_STATE_CONTRACT_LIST: 'contract/clearMapStateContractList',
    SET_CONTRACT_SEARCH_CRITERIA: 'contract/setContractSearchCriteria',
    SET_CONTRACT_LIST_CURRENT_PAGE: 'contract/setContractListCurrentPage',
    SET_CONTRACT_PAGE_LIST_STORE: 'contract/setContractPageListStore',
    SET_CONTRACT_LIST_LAST_ID: 'contract/setContractListLastId',
    UPDATE_CONTRACT_PAGE_LIST_STORE: 'contract/updateContractPageListStore'
  },
  SPECIAL_OFFER: {
    CLEAR_MAP_STATE_SPECIAL_OFFER_LIST: 'specialOffer/clearMapStateSpecialOfferList',
    SET_SPECIAL_OFFER_SEARCH_CRITERIA: 'specialOffer/setSpecialOfferSearchCriteria',
    SET_SPECIAL_OFFER_LIST_CURRENT_PAGE: 'specialOffer/setSpecialOfferListCurrentPage',
    SET_SPECIAL_OFFER_PAGE_LIST_STORE: 'specialOffer/setSpecialOfferPageListStore',
    SET_SPECIAL_OFFER_LIST_LAST_ID: 'specialOffer/setSpecialOfferListLastId',
    UPDATE_SPECIAL_OFFER_PAGE_LIST_STORE: 'specialOffer/updateSpecialOfferPageListStore'
  },
  EMAIL_HISTORY: {
    SET_EMAIL_HISTORY_LIST_CURRENT_PAGE: 'emailHistory/setEmailHistoryListCurrentPage',
    SET_EMAIL_HISTORY_PAGE_LIST_STORE: 'emailHistory/setEmailHistoryPageListStore',
    SET_EMAIL_HISTORY_LIST_LAST_ID: 'emailHistory/setEmailHistoryListLastId'
  }
}

export const DOCUMENT_TYPE = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'

export const EMAIL_SEND_TYPE = {
  GENERAL: 'general',
  STOP_SALE: 'stopSale',
  CONTRACT: 'contract',
  SPECIAL_OFFER: 'specialOffer'
}

export const EMAIL_STATUS = {
  PROCESSING: 1,
  SUCCESS: 10,
  FAIL: 0
}
